import React from 'react';
import * as styles from './TopicIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import topicIcon from '../icons/prefilled/16x16/topic.svg';

const TopicIcon = () => (
  <div className={styles.container}>
    <SVGIcon>{topicIcon}</SVGIcon>
  </div>
);

export default TopicIcon;
